import { create } from 'zustand';
import type { Anchor } from '../components/Popover';
import type { ExtraContext, ExtraMenuItem } from '../features/extras';

/** Dialoge, die von überall geöffnet werden können (gerendert in shell/GlobalOverlays). */
export type Dialog =
  | { type: 'createServer' }
  | { type: 'joinServer' }
  | { type: 'invite'; serverId: string; channelId?: string }
  | { type: 'createChannel'; serverId: string; parentId?: string | null; defaultType?: 'TEXT' | 'VOICE' | 'CATEGORY' | 'FORUM' | 'ANNOUNCEMENT' }
  | { type: 'newDm'; channelId?: string }
  | { type: 'customStatus' }
  | { type: 'notificationSettings'; serverId: string; channelId?: string }
  | { type: 'extra'; item: ExtraMenuItem; ctx: ExtraContext };

/** Schwebende Elemente an einem Anker. */
export type Popout = { type: 'profile'; userId: string; serverId?: string | null; anchor: Anchor } | { type: 'inbox'; anchor: Anchor };

interface OverlayState {
  dialog: Dialog | null;
  popout: Popout | null;
  openDialog(d: Dialog): void;
  closeDialog(): void;
  openPopout(p: Popout): void;
  closePopout(): void;
}

export const useOverlays = create<OverlayState>((set) => ({
  dialog: null,
  popout: null,
  openDialog: (dialog) => set({ dialog, popout: null }),
  closeDialog: () => set({ dialog: null }),
  openPopout: (popout) => set({ popout }),
  closePopout: () => set({ popout: null }),
}));

export const overlays = {
  open: (d: Dialog) => useOverlays.getState().openDialog(d),
  profile: (userId: string, anchor: Anchor, serverId?: string | null) => useOverlays.getState().openPopout({ type: 'profile', userId, anchor, serverId }),
  close: () => useOverlays.getState().closeDialog(),
};
